export const
    UNSELECTED_PRODUCT = "Brak wybranego produktu!",
    AMOUNT_VALUE_IS_ZERO_OR_LESS_THAN_ZERO = "Ilość musi być większa niż 0!",
    EMPTY_FAULT_DESCRIPTION = "Pole opis wady fizycznej nie może być puste!",
    EMPTY_FAULT_DISCOVERY_CIRCUMSTANCES = "Pole okoliczności wykrycia wady nie może być puste!",
    EMPTY_CUSTOMER_REQUEST = "Pole oczekiwania reklamującego nie może być puste!",
    INVALID_FAULT_DATE = "Wpowadzona data jest niepoprawna!",
    EMPTY_SHIPMENT_DESCRIPTION = "Pole opis przesyłki nie może być puste!",
    EMPTY_INVOICE_QUANTITY= "Ilość według faktury nie może być ujemna!",
    EMPTY_SHIPPED_QUANTITY= "Dostarczona ilość nie może być ujemna!",
    EMPTY_ARTICLE_SERIAL_NUMBER="Pole numer seryjny artykułu nie może być puste!",
    UNSELECTED_TERM_OF_USE = "Należy zaakceptować warunki!",
    NO_FILES_ADDED = "Nie podpięto załączników!",
    NO_PURCHASE_PROOF = "Brak dowodu zakupu!",
    UNSELECTED_QUANTITY_CPRRECTIONS_PROPOSAL = "Brak określonego sposobu rozpatrzenia reklamacji!",
    UNSELECTED_COURIER = "Brak określonego przwoźnika!",
    EMPTY_SALES_DOCUMENT_NUMBER= "Pole numer dokumentu sprzedaży nie może być puste!",
    EMPTY_SALES_DOCUMENT_POSITION= "Pole pozycja dokumentu sprzedaży nie może być puste!",
    FETCH_ERRROR_GET_SALES_DOCUMENT_BY_NUMBER_AND_CUSTOMER_ID = "Wystąpił błąd podczas pobierania dokumnetu sprzedaży",
    INCORRECT_PURCHASE_DATE = "Niepoprawna data zakupu",
    PURCHASE_DATE_REQUIRE = "Pole data zakupu nie może być puste!",
    TOSHORT_ARTICLE_SERIAL_NUMBER = "Numer seryjny jest za krótki (powinien mieć 22 lub 23 bez spacji)",
    TOLONG_ARTICLE_SERIAL_NUMBER = "Numer seryjny jest za długi (powinien mieć 22 lub 23 bez spacji)",
    EMPTY_ASSEMBLY_ADDRESS = "Adres montażu nie może być pusty",
    SALES_DOCUMENT_DOESNT_EXISTS = "Nie znaleziono dokumentu sprzedaży o podanym numerze!";


// WEBPACK FOOTER //
// ./src/const/ErrorMessages/ComplaintPositionErrorMessages.js